import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { EventListener } from '../../../../../lib/web/components/event-listener';
import { Input } from '../../../../../lib/web/components/input';
import { ApiService } from '../../../services/api.service';
import { SessionService } from '../../../services/session.service';
import { GridComponent } from '../../organisms/grid/grid.component';

@Component({
    selector: '.p-accessible-content'
})
export class AccessibleContentComponent extends ComponentBase<HTMLElement> {

    @Input('totalPages')
    private _totalPages: number = null;

    @ChildRef()
    private _grid: GridComponent = null;

    public constructor(node: HTMLElement, private _apiService: ApiService, private _sessionService: SessionService) {
        super(node);       
    }

    public onInit(mode: 'load' | 'redirect'): void {
        super.onInit(mode);
        this._grid.addCustomEventListener('load-page', (data: { page: number }) => this.loadPage(data));
    }

    @EventListener('selection-changed', '.a-tab')
    public onTabSelectionChanged(e: CustomEvent): void {
        const { id } = e.detail;
        this.replaceState(id === 'all' ? location.pathname : `${location.pathname}?accessibility=${id}`);
        this._grid.reset();
    }

    private async loadPage(data: { page: number }): Promise<void> {
        const { page } = data;
        const accessibility: string = new URLSearchParams(location.search).get('accessibility');
        const response: { grid: { title: string, items: any[], pageInfo: { currentPage: number, totalPages: number } }, defaultGrid: { title: string, items: any[], pageInfo: { currentPage: number, totalPages: number } } } = await this._apiService.get('/api/v1/content/accessible-content', {
            query: {
                page,
                ...(accessibility ? { accessibility } : {})
            }
        });
        const { grid } = response;
        this._totalPages = grid.pageInfo.totalPages;
        this._grid.setPageResponse(grid.items, grid.pageInfo);
    }
}